// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__25ake","p0Login":"styles_p0Login__2NZvQ","modal":"styles_modal__2M236","modalContent":"styles_modalContent__3thKM"};